export default class PackageService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllPricePackages(args) {
    return this.axiosIns.get(`${this.serviceConfig.packages}`, { params: args });
  }

  getPricePackage(id) {
    return this.axiosIns.get(`${this.serviceConfig.packages}/${id}`);
  }

  createPricePackage(args) {
    return this.axiosIns.post(`${this.serviceConfig.packages}`, args);
  }

  editPricePackage(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.packages}/${id}`, args);
  }

  deletePricePackage(id) {
    return this.axiosIns.delete(`${this.serviceConfig.packages}/${id}`);
  }

  getPackageProvider(packageId, providerId) {
    return this.axiosIns.get(
      `${this.serviceConfig.packages}/${packageId}/provider/${providerId}/region-rates`
    );
  }

  getRegionRate(packageId, regionId) {
    return this.axiosIns.get(
      `${this.serviceConfig.packages}/${packageId}/region-rates/${regionId}`
    );
  }

  createPackageProvider(packageId, args) {
    return this.axiosIns.post(`${this.serviceConfig.packages}/${packageId}/region-rates`, args);
  }

  deletePackageProvider(packageId, regionId) {
    return this.axiosIns.delete(
      `${this.serviceConfig.packages}/${packageId}/region-rates/${regionId}`
    );
  }

  getPackages() {
    return this.axiosIns.get(`${this.serviceConfig.packages}?limit=1000`);
  }
}
